import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showMessage, setBrokerTimeZone } from "store/reducers/common.slice";
import axios from "axios";
import _ from "lodash";
import { getSessionData } from "utils/common";
import { setMarketWatchList } from "./marketWatch.slice";
import { getSessionDataOnlyRead } from "utils/common";
import {
  applySessionAuthHeaders,
  persistTradeSession,
  setRememberLoginUsername,
  validateLoginApiResponse,
} from "utils/authCookies";
import { loadBrokerTimeZoneFromApi } from "utils/loadBrokerTimeZone";
import { isUsableIanaTimeZone } from "utils/dateFormats";
const initialState = {
  isLoading: true,
  isLogOut: false,
  rulesAccepted: true,
  isShowChangePassword: false,
  isUserAuthenticated: false,
  isResetPassword: false,
  loginLoading: false,
  otpSent: false,
  registerLoading: false,
  InstantDemoLoading: false,
  userIp: "",
  isVerifyPassword: false,
  userRole: "",
  isMasterRole: "",
  isUserLogin: false,
  device: "",
  isRegister: false,
};

const getIpAddress = () => {
  const timeoutMs = 2500;
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(""), timeoutMs);
    fetch("https://api.ipify.org/?format=json")
      .then((data) => data.json())
      .then((data) => {
        clearTimeout(timer);
        resolve(data?.ip ? String(data.ip) : "");
      })
      .catch(() => {
        clearTimeout(timer);
        resolve("");
      });
  });
};

export const loginAction = createAsyncThunk("auth/login", (dataProp, { dispatch }) => {
  return new Promise((resolve, reject) => {
    let dataF = _.omit(dataProp, ["tc"]);
    dataF.deviceType = 1;
    dataF.sourceDevice = navigator.userAgent;
    let { username, password, isRemember, IsUserLogin } = dataF;
    getIpAddress()
      .then((ipData) => {
        const userIpData = ipData || "";
        dataF.userIp = userIpData;
        dataF.projectType = 1;
        dataF.totp = dataF.totp ? dataF.totp : 0;
        let fcmToken = localStorage.getItem("fcmToken");
        if (fcmToken) {
          dataF.fcmToken = fcmToken;
        }
        setRememberLoginUsername(username, isRemember);
        axios
          .post("user/login", dataF, { withCredentials: true })
          .then(({ data }) => {
            const loginCheck = validateLoginApiResponse(data);
            if (!loginCheck.ok) {
              dispatch(showMessage({ message: loginCheck.message }));
              reject({ message: loginCheck.message });
              return;
            }
            const finalData = loginCheck.finalData;
            sessionStorage.setItem("loggedInUrl", window.location.pathname);
            finalData.userIpFinal = finalData.ip;
            finalData.isRemember = isRemember;
            if (IsUserLogin) {
              finalData.IsUserLogin = IsUserLogin;
            }
            dispatch(setIsUserLogin(IsUserLogin));
            const role0 = finalData.roles?.[0] || finalData.Roles?.[0] || "";
            if (role0 === "User" && password === "Aabb@1122") {
              dispatch(setIsShowChangePassword(true));
              finalData.isShowChangePassword = true;
            }
            const stored = persistTradeSession(finalData);
            if (role0 === "User" && !finalData?.rulesAccepted) {
              dispatch(setRulesAccepted(finalData?.rulesAccepted));
            }
            applySessionAuthHeaders(stored);
            loadBrokerTimeZoneFromApi()
              .then((tz) => {
                if (isUsableIanaTimeZone(tz)) dispatch(setBrokerTimeZone(tz));
              })
              .catch(() => {});
            dispatch(showMessage({ message: data.message, varient: "success" }));
            dispatch(setUserLogInIp(userIpData));
            resolve({
              data,
              userIp: userIpData,
            });
          })
          .catch((error) => {
            if (error.response) {
              dispatch(showMessage({ message: error.response.data.message }));
            } else if (error.request) {
              dispatch(showMessage({ message: error.request.message }));
            } else {
              dispatch(showMessage({ message: error.message }));
            }
            reject(error);
          });
      })
      .catch((error) => {
        if (error.response) {
          dispatch(showMessage({ message: error.response.data.message }));
        } else if (error.request) {
          dispatch(showMessage({ message: error.request.message }));
        } else {
          dispatch(showMessage({ message: error.message }));
        }
        reject(error);
      });
  });
});
export const instantDemo = createAsyncThunk("auth/instant-demo", (dataProp, { dispatch }) => {
  return new Promise((resolve, reject) => {
    let dataF = {
      deviceType: 1,
      sourceDevice: navigator.userAgent,
      username: "abc",
      password: "abc",
      isRemember: false,
      IsUserLogin: true,
    };
    let { username, password, isRemember, IsUserLogin } = dataF;
    getIpAddress()
      .then((ipData) => {
        const userIpData = ipData || "";
        dataF.userIp = userIpData;
        dataF.projectType = 1;
        dataF.totp = dataF.totp ? dataF.totp : 0;
        let fcmToken = localStorage.getItem("fcmToken");
        if (fcmToken) {
          dataF.fcmToken = fcmToken;
        }
        setRememberLoginUsername(username, isRemember);
        axios
          .post("user/InstantDemo", dataF, { withCredentials: true })
          .then(({ data }) => {
            const loginCheck = validateLoginApiResponse(data);
            if (!loginCheck.ok) {
              dispatch(showMessage({ message: loginCheck.message }));
              reject({ message: loginCheck.message });
              return;
            }
            const finalData = loginCheck.finalData;
            sessionStorage.setItem("loggedInUrl", window.location.pathname);
            finalData.userIpFinal = finalData.ip;
            finalData.isRemember = isRemember;
            if (IsUserLogin) {
              finalData.IsUserLogin = IsUserLogin;
            }
            dispatch(setIsUserLogin(IsUserLogin));
            const role0 = finalData.roles?.[0] || finalData.Roles?.[0] || "";
            if (role0 === "User" && password === "Aabb@1122") {
              dispatch(setIsShowChangePassword(true));
              finalData.isShowChangePassword = true;
            }
            const stored = persistTradeSession(finalData);
            if (role0 === "User" && !finalData?.rulesAccepted) {
              dispatch(setRulesAccepted(finalData?.rulesAccepted));
            }
            applySessionAuthHeaders(stored);
            dispatch(showMessage({ message: data.message, varient: "success" }));
            dispatch(setUserLogInIp(userIpData));
            resolve({
              data,
              userIp: userIpData,
            });
          })
          .catch((error) => {
            if (error.response) {
              dispatch(showMessage({ message: error.response.data.message }));
            } else if (error.request) {
              dispatch(showMessage({ message: error.request.message }));
            } else {
              dispatch(showMessage({ message: error.message }));
            }
            reject(error);
          });
      })
      .catch((error) => {
        if (error.response) {
          dispatch(showMessage({ message: error.response.data.message }));
        } else if (error.request) {
          dispatch(showMessage({ message: error.request.message }));
        } else {
          dispatch(showMessage({ message: error.message }));
        }
        reject(error);
      });
  });
});
export const register = createAsyncThunk("auth/register", (dataProp, { dispatch }) => {
  return new Promise((resolve, reject) => {
    let dataF = {
      MobileNumber: dataProp.countyCode + "~" + dataProp.MobileNumber,
      AccountName: dataProp.AccountName,
      AccountCode: dataProp.AccountCode,
      Password: dataProp.password,
      ProjectType: 1,
      ReferralBy: dataProp.ReferralBy,
      deviceType: 1,
      sourceDevice: navigator.userAgent,
      OTP: dataProp.otp,
    };
    getIpAddress()
      .then((ipData) => {
        const userIpData = ipData || "";
        dataF.userIp = userIpData;
        let fcmToken = localStorage.getItem("fcmToken");
        if (fcmToken) {
          dataF.fcmToken = fcmToken;
        }
        axios
          .post("master/account/online-register-account", dataF)
          .then(({ data }) => {
            if (data.status === 200) {
              dispatch(showMessage({ message: data.message, varient: "success" }));
              resolve(data);
            } else {
              dispatch(showMessage({ message: data.message }));
              reject({ message: data.message });
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(showMessage({ message: error.response.data.message }));
            } else if (error.request) {
              dispatch(showMessage({ message: error.request.message }));
            } else {
              dispatch(showMessage({ message: error.message }));
            }
            reject(error);
          });
      })
      .catch((error) => {
        if (error.response) {
          dispatch(showMessage({ message: error.response.data.message }));
        } else if (error.request) {
          dispatch(showMessage({ message: error.request.message }));
        } else {
          dispatch(showMessage({ message: error.message }));
        }
        reject(error);
      });
  });
});
export const sendOtp = createAsyncThunk("auth/sendotp", (dataProp, { dispatch }) => {
  return new Promise((resolve, reject) => {
    let dataF = {
      MobileNumber: dataProp.countyCode + "~" + dataProp.MobileNumber,
      AccountName: dataProp.AccountName,
      AccountCode: dataProp.AccountCode,
      Password: dataProp.password,
      ProjectType: 1,
      ReferralBy: dataProp.ReferralBy,
    };
    axios
      .post("master/account/otp-send-online-register-account", dataF)
      .then(({ data }) => {
        if (data.status === 200) {
          dispatch(showMessage({ message: data.message, varient: "success" }));
          resolve(data);
        } else {
          dispatch(showMessage({ message: data.message }));
          reject({ message: data.message });
        }
      })
      .catch((error) => {
        if (error.response) {
          dispatch(showMessage({ message: error.response.data.message }));
        } else if (error.request) {
          dispatch(showMessage({ message: error.request.message }));
        } else {
          dispatch(showMessage({ message: error.message }));
        }
        reject(error);
      });
  });
});
export const resendOtp = createAsyncThunk("auth/resendotp", (dataProp, { dispatch }) => {
  return new Promise((resolve, reject) => {
    let dataF = {
      MobileNumber: dataProp.countyCode + "~" + dataProp.MobileNumber,
      AccountName: dataProp.AccountName,
      AccountCode: dataProp.AccountCode,
      Password: dataProp.password,
      ProjectType: 1,
      ReferralBy: dataProp.ReferralBy,
    };
    axios
      .post("master/account/otp-resend-online-register-account", dataF)
      .then(({ data }) => {
        if (data.status === 200) {
          dispatch(showMessage({ message: data.message, varient: "success" }));
          resolve(data);
        } else {
          dispatch(showMessage({ message: data.message }));
          reject({ message: data.message });
        }
      })
      .catch((error) => {
        if (error.response) {
          dispatch(showMessage({ message: error.response.data.message }));
        } else if (error.request) {
          dispatch(showMessage({ message: error.request.message }));
        } else {
          dispatch(showMessage({ message: error.message }));
        }
        reject(error);
      });
  });
});
export const logOut = createAsyncThunk("auth/logout", (data, { getState, dispatch }) => {
  return new Promise((resolve, reject) => {
    //_.omit(data, ['totp', 'tc'])
    let { userId, userIpFinal, isRemember, IsUserLogin } = getSessionData();
    data.deviceType = 1;
    data.id = userId;
    data.sourceDevice = navigator.userAgent;
    data.userIp = userIpFinal;
    axios
      .post("user/log-out", data, { withCredentials: true })
      .then(({ data }) => {
        if (data.status == 200) {
          if (!isRemember) {
            setRememberLoginUsername("", false);
          }
          dispatch(setIsUserLogin(IsUserLogin));
          sessionStorage.removeItem("TradeSession");
          sessionStorage.removeItem("DeviceType");
          sessionStorage.removeItem("TradeAuthoritySession");
          axios.defaults.headers.common["Authorization"] = "";
          localStorage.removeItem("fcmToken");
          dispatch(showMessage({ message: data.message, varient: "success" }));
          dispatch(setMarketWatchList());
          resolve(data);
        } else {
          sessionStorage.removeItem("TradeSession");
          sessionStorage.removeItem("DeviceType");
          sessionStorage.removeItem("TradeAuthoritySession");
          axios.defaults.headers.common["Authorization"] = "";
          localStorage.removeItem("fcmToken");
          reject(data);
        }
      })
      .catch((error) => {
        if (error.response) {
          dispatch(showMessage({ message: error.response.data.message }));
        } else if (error.request) {
          dispatch(showMessage({ message: error.request.message }));
        } else {
          dispatch(showMessage({ message: error.message }));
        }
        reject(error);
      });
  });
});

export const resetPassword = createAsyncThunk(
  "auth/reset-password",
  (data, { getState, dispatch }) => {
    return new Promise((resolve, reject) => {
      const { userName } = getSessionData();
      let finalObject = {};
      finalObject = data;
      finalObject.userName = userName;
      axios
        .post("user/reset-password", data)
        .then((res) => {
          if (res.data?.status === 200) {
            let sessionData = getSessionDataOnlyRead();
            sessionStorage.setItem("TradeSession", window.btoa(JSON.stringify(sessionData)));
            dispatch(showMessage({ message: res?.data?.message, varient: "success" }));
            resolve(res);
          } else {
            dispatch(showMessage({ message: res.data?.message }));
            reject({ message: res.data?.message });
          }
        })
        .catch((errors) => {
          if (errors.response) {
            dispatch(showMessage({ message: errors.response.data.title }));
          } else if (errors.request) {
            dispatch(showMessage({ message: errors.request.title }));
          } else {
            dispatch(showMessage({ message: errors.message }));
          }
          reject(errors);
        });
    });
  }
);
export const checkVerifyPassword = createAsyncThunk(
  "auth/verify-password",
  (password, { getState, dispatch }) => {
    return new Promise((resolve, reject) => {
      const { userName } = getSessionData();
      const object = { userName, password };
      axios
        .post("user/password-verify", object)
        .then(({ data }) => {
          if (data?.status === 200) {
            resolve({ isVerifyPassword: true });
          } else {
            dispatch(showMessage({ message: data.message }));
          }
        })
        .catch((errors) => {
          if (errors.response) {
            dispatch(showMessage({ message: errors.response.data.title }));
          } else if (errors.request) {
            dispatch(showMessage({ message: errors.request.title }));
          } else {
            dispatch(showMessage({ message: errors.message }));
          }
          reject(errors);
        });
    });
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserLogInIp: (state, action) => {
      state.userIp = action.payload;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
    setUserAuthenticated: (state, action) => {
      state.isUserAuthenticated = action.payload;
    },
    setIsResetPassword: (state, action) => {
      state.isResetPassword = action.payload;
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload;
    },
    setIsMasterRole: (state, action) => {
      state.isMasterRole = action.payload;
    },
    setIsLogout: (state, action) => {
      state.isLogOut = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsUserLogin: (state, action) => {
      state.isUserLogin = action.payload;
    },
    setUserDevice: (state, action) => {
      state.device = action.payload;
      if (action.payload) {
        sessionStorage.setItem("DeviceType", window.btoa(JSON.stringify(action.payload)));
      }
    },
    setRulesAccepted: (state, action) => {
      state.rulesAccepted = action.payload;
    },
    setIsShowChangePassword: (state, action) => {
      state.isShowChangePassword = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginAction.pending, (state) => {
      state.isUserAuthenticated = false;
      state.loginLoading = true;
    });

    builder.addCase(loginAction.rejected, (state) => {
      state.isUserAuthenticated = false;
      state.loginLoading = false;
    });

    builder.addCase(loginAction.fulfilled, (state, action) => {
      if (action.payload.data.status == 200) {
        state.userIp = action.payload.userIp;
        state.isUserAuthenticated = true;
        state.loginLoading = false;
      }
    });

    builder.addCase(instantDemo.pending, (state) => {
      state.isUserAuthenticated = false;
      state.InstantDemoLoading = true;
    });

    builder.addCase(instantDemo.rejected, (state) => {
      state.isUserAuthenticated = false;
      state.InstantDemoLoading = false;
    });

    builder.addCase(instantDemo.fulfilled, (state, action) => {
      if (action.payload.data.status == 200) {
        state.userIp = action.payload.userIp;
        state.isUserAuthenticated = true;
        state.InstantDemoLoading = false;
      }
    });

    builder.addCase(sendOtp.pending, (state) => {
      state.otpSent = false;
      state.registerLoading = true;
    });

    builder.addCase(sendOtp.rejected, (state) => {
      state.otpSent = false;
      state.registerLoading = false;
    });

    builder.addCase(sendOtp.fulfilled, (state, action) => {
      state.otpSent = true;
      state.registerLoading = false;
    });

    builder.addCase(resendOtp.pending, (state) => {
      state.registerLoading = true;
    });

    builder.addCase(resendOtp.rejected, (state) => {
      state.registerLoading = false;
    });

    builder.addCase(resendOtp.fulfilled, (state, action) => {
      state.registerLoading = false;
    });

    builder.addCase(register.pending, (state) => {
      state.registerLoading = true;
      state.isRegister = false;
    });

    builder.addCase(register.rejected, (state) => {
      state.registerLoading = false;
      state.isRegister = false;
    });

    builder.addCase(register.fulfilled, (state, action) => {
      state.registerLoading = false;
      state.isRegister = true;
    });

    builder.addCase(logOut.pending, (state) => {
      state.isUserAuthenticated = false;
    });

    builder.addCase(logOut.rejected, (state) => {
      state.isUserAuthenticated = false;
      state.loginLoading = false;
      state.isLogOut = true;
    });

    builder.addCase(logOut.fulfilled, (state, action) => {
      state.userIp = "";
      state.isUserAuthenticated = false;
      state.isLogOut = true;
      state.loginLoading = false;
    });

    builder.addCase(resetPassword.pending, (state) => {
      state.isResetPassword = false;
      state.loginLoading = true;
    });

    builder.addCase(resetPassword.rejected, (state) => {
      state.isResetPassword = false;
      state.loginLoading = false;
    });

    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.loginLoading = false;
      state.isResetPassword = true;
    });
  },
});

export const {
  decrement,
  setUserLogInIp,
  incrementByAmount,
  setUserAuthenticated,
  setUserRole,
  setIsMasterRole,
  setIsLogout,
  setIsLoading,
  setIsUserLogin,
  setUserDevice,
  setRulesAccepted,
  setIsShowChangePassword,
  setIsResetPassword,
} = authSlice.actions;

export default authSlice.reducer;
